import React, { createContext, useContext, useReducer } from 'react'
import cuid from 'cuid'
import * as _ from 'lodash'
import { EUserOnboardingActionTypes } from 'models'

interface IUserOnboardingProvider {
	userOnboarding?: any
	storeUserId?: string
	reset?: boolean
}

let initialUserOnboardingState: any = {
	id: '',
	firstName: '',
	lastName: '',
	aboutMe: '',
	imageCover: '',
	imageAvatar: '',
	skills: [],
	values: [],
	userCv: '',
	experience: {
		title: '',
		description: '',
		startDatetime: '',
		endDatetime: '',
		region: '',
		location: '',
		company: '',
		position: '',
		isCurrent: false,
		isPresent: false,
	},
	error: {
		firstName: false,
		lastName: false,
		aboutMe: false,
		imageCover: false,
		imageAvatar: false,
		skills: false,
		values: false,
		experience: {
			title: false,
			description: false,
			startDatetime: false,
			endDatetime: false,
			region: false,
			location: false,
			company: false,
		},
		userCv: false,
	},
}
const UserOnboardingContext: React.Context<any> = createContext<any>(null)

const reducer: React.Reducer<any, any> = (state: any, action: any) => {
	switch (action.type) {
		case EUserOnboardingActionTypes.resetState: {
			return { ...state, ...initialUserOnboardingState }
		}
		case EUserOnboardingActionTypes.setFirstName: {
			return {
				...state,
				firstName: action.firstName,
				error: {
					...state.error,
					firstName: _.isEmpty(action.firstName),
				},
			}
		}
		case EUserOnboardingActionTypes.setLastName:
			return {
				...state,
				lastName: action.lastName,
				error: {
					...state.error,
					lastName: _.isEmpty(action.lastName),
				},
			}
		case EUserOnboardingActionTypes.setAboutMe:
			return {
				...state,
				aboutMe: action.aboutMe,
				error: {
					...state.error,
					aboutMe: _.isEmpty(action.aboutMe),
				},
			}

		case EUserOnboardingActionTypes.setImageCover:
			return {
				...state,
				imageCover: action.imageCover,
				error: {
					...state.error,
					imageCover: _.isEmpty(action.imageCover),
				},
			}
		case EUserOnboardingActionTypes.setUserCv:
			return {
				...state,
				userCv: action.userCv,
				error: {
					...state.error,
					userCv: _.isEmpty(action.userCv),
				},
			}
		case EUserOnboardingActionTypes.setError: {
			return {
				...state,
				error: {
					...state.error,
					...action.errors,
					experience: {
						...state.error.experience,
						...action.errors.experience,
					},
				},
			}
		}
		case EUserOnboardingActionTypes.setImageAvatar:
			return {
				...state,
				imageAvatar: action.imageAvatar,
				error: {
					...state.error,
					imageAvatar: _.isEmpty(action.imageAvatar),
				},
			}

		case EUserOnboardingActionTypes.setSkills:
			return {
				...state,
				skills: action.skills,
				error: {
					...state.error,
					skills: _.isEmpty(action.skills),
				},
			}
		case EUserOnboardingActionTypes.setValues:
			return {
				...state,
				values: action.value,
				error: {
					...state.error,
					values: _.isEmpty(action.value),
				},
			}
		case EUserOnboardingActionTypes.setExperienceTitle:
			return {
				...state,
				experience: {
					...state.experience,
					title: action.title,
				},
				error: {
					...state.error,
					experience: {
						...state.error.experience,
						title: _.isEmpty(action.title),
					},
				},
			}
		case EUserOnboardingActionTypes.setExperienceDesc:
			return {
				...state,
				experience: {
					...state.experience,
					description: action.description,
				},
				error: {
					...state.error,
					experience: {
						...state.error.experience,
						description: _.isEmpty(action.description),
					},
				},
			}
		case EUserOnboardingActionTypes.setExperienceStartDatetime:
			return {
				...state,
				experience: {
					...state.experience,
					startDatetime: action.startDatetime,
				},
				error: {
					...state.error,
					experience: {
						...state.error.experience,
						startDatetime: _.isEmpty(action.startDatetime),
					},
				},
			}
		case EUserOnboardingActionTypes.setExperienceEndDatetime:
			return {
				...state,
				experience: {
					...state.experience,
					endDatetime: action.endDatetime,
				},
				error: {
					...state.error,
					experience: {
						...state.error.experience,
						endDatetime: _.isEmpty(action.endDatetime),
					},
				},
			}
		case EUserOnboardingActionTypes.setExperienceRegion:
			return {
				...state,
				experience: {
					...state.experience,
					region: action.region,
				},
				error: {
					...state.error,
					experience: {
						...state.error.experience,
						region: _.isEmpty(action.region),
					},
				},
			}
		case EUserOnboardingActionTypes.setExperienceLocation:
			return {
				...state,

				experience: {
					...state.experience,
					location: action.location,
				},
				error: {
					...state.error,
					experience: {
						...state.error.experience,
						location: _.isEmpty(action.location),
					},
				},
			}
		case EUserOnboardingActionTypes.setExperienceCompany:
			return {
				...state,

				experience: {
					...state.experience,
					company: action.company,
				},
				error: {
					...state.error,
					experience: {
						...state.error.experience,
						company: _.isEmpty(action.company),
					},
				},
			}
		case EUserOnboardingActionTypes.setExperienceIsPresent:
			return {
				...state,

				experience: {
					...state.experience,
					isPresent: action.isPresent,
					endDatetime: '', // reset endDateTime anytime isPresent is changed
				},
				error: {
					...state.error,
					experience: {
						...state.error.experience,
						endDatetime: !action.isPresent,
					},
				},
			}
		case EUserOnboardingActionTypes.setExperienceIsCurrent:
			return {
				...state,

				experience: {
					...state.experience,
					isCurrent: action.isCurrent,
				},
			}
		case EUserOnboardingActionTypes.setExperiencePosition:
			return {
				...state,

				experience: {
					...state.experience,
					position: action.position,
				},
			}
		case EUserOnboardingActionTypes.setExperience:
			return {
				...state,
				experience: action.experience,
				error: {
					...state.error,
					experience: _.isEmpty(action.experience),
				},
			}
		default:
			return state
	}
}

export const UserProvider: React.FunctionComponent<IUserOnboardingProvider> = ({
	children,
	userOnboarding,
	storeUserId,
	reset = false,
}) => {
	let state: any = { ...initialUserOnboardingState }
	if (!reset && userOnboarding) {
		if (userOnboarding.id) state.id = userOnboarding.id
		state = {
			...state,
		}
	}
	if (!state.id) {
		state.id = cuid()
	}
	if (!state.ownerId) {
		state.ownerId = storeUserId
	}
	return (
		<UserOnboardingContext.Provider
			value={useReducer(reducer, {
				...state,
			})}
		>
			{children}
		</UserOnboardingContext.Provider>
	)
}

interface IUserOnboardingStateValue {
	children: any
	keys: any
}

export const UserOnboardingStateValue = ({
	children,
	keys = [],
}: IUserOnboardingStateValue) => {
	let [state, userOnBoardDispatch] = useContext(UserOnboardingContext)
	const keysMap: any = {}
	keys.map((item: any) => {
		keysMap[item] =
			item.indexOf('|') === -1
				? item.split('.')
				: item.split('|')[0].split('.')
		return undefined
	})
	let result: { [key: string]: any } = []
	keys.map((item: any) => {
		const last =
			item.indexOf('|') === -1
				? [...keysMap[item]].reverse()[0]
				: item.split('|')[1]
		if (typeof keysMap[item] === 'object') {
			result[last] = keysMap[item].reduce(
				(a: any, c: any) => (a !== null ? a[c] : null),
				state,
			)
		} else {
			result[last] = state[keysMap[item]]
		}
		return undefined
	})

	if (keys.indexOf('userOnBoardDispatch') !== -1)
		result['userOnBoardDispatch'] = userOnBoardDispatch

	// TODO: update with a proper interface.
	let elements: any = React.Children.toArray(children)
	if (elements.length === 1) {
		elements = React.cloneElement(elements[0], result)
	} else if (elements.length > 0) {
		for (let i in elements) {
			elements[i] = React.cloneElement(elements[i], result)
		}
	}
	return <>{elements}</>
}
